import styled from 'styled-components';

export const FaqThemeContainer = styled.div`
    h2,
    h2:first-child {
        font-weight: ${props => props.theme.boldWeight};
        font-size: 16px;
        text-transform: none;
    }
    h2::after {
        height: 3px;
        width: 100%;
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/faq/FaqThemeComponentStyle.js